// extracted by mini-css-extract-plugin
export default {"mainBodySection":"styles_mainBodySection__Tx+7u","heading":"styles_heading__jw7eQ","horizontalRule":"styles_horizontalRule__gTEqd","entryList":"styles_entryList__CGlFt"};